var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayer6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 138,
    viewBox: "0 0 68 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5002 27.2402C68.6867 79.3615 34.0866 120.064 12.3883 133.9L12.3883 137.578C71.5016 95.5443 51.0935 46.5055 33.5002 27.2402Z",
    fill: "#CAD0E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.301 24.0877C23.3841 19.1838 6.14268 7.58963 0.51284 0.443976C9.16286 0.794252 27.4305 6.01338 31.301 24.0877Z",
    fill: "#CAD0E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7782 43.0027C34.0866 44.0535 22.2405 43.1078 12.3883 30.9181C18.1704 28.6413 31.5434 27.8707 38.7782 43.0027Z",
    fill: "#CAD0E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9358 73.4768C40.2443 71.5503 30.4214 64.2295 28.6621 50.3585C35.2595 50.5336 47.7507 55.4025 44.9358 73.4768Z",
    fill: "#CAD0E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7782 100.798C35.1129 98.5216 28.2222 89.8698 29.9816 73.4768C36.2858 75.4033 46.8711 83.5648 38.7782 100.798Z",
    fill: "#CAD0E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4256 125.493C17.8129 120.064 15.9949 106.893 21.6248 97.646C27.0493 100.974 34.2039 111.202 19.4256 125.493Z",
    fill: "#CAD0E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6621 128.646C32.0341 123.391 42.6487 112.042 58.1308 108.68C54.7587 117.612 44.1441 134.11 28.6621 128.646Z",
    fill: "#CAD0E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5748 100.798C50.0672 93.4426 57.427 77.9954 66.9274 75.0531C67.9376 83.6349 65.4813 100.798 47.5748 100.798Z",
    fill: "#CAD0E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7324 71.9006C53.2925 62.7934 54.2602 43.7383 61.6493 40.3756C65.7544 48.0817 69.9181 65.1752 53.7324 71.9006Z",
    fill: "#CAD0E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5748 40.3756C47.5748 40.3756 37.4586 28.291 43.1764 8.85063C49.3341 15.751 58.8345 31.7165 47.5748 40.3756Z",
    fill: "#CAD0E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer6);
export default __webpack_public_path__ + "static/media/Layer_6.c00eb1258fde00afe783c1857bb90790.svg";
export { ForwardRef as ReactComponent };